<script lang="ts">
	import { PUBLIC_LOL_CDN_URL } from '$env/static/public';
	import Badge from '$lib/components/ui/badge/badge.svelte';
	import { cn } from '$lib/utils';
	import { onDestroy } from 'svelte';
	import { inview } from 'svelte-inview';

	const options = {};
	let intervalId: number | undefined;
	let activeId = 2;

	function startAnimation() {
		clearInterval(intervalId);
		intervalId = setInterval(() => {
			if (activeId < 4) {
				activeId++;
			} else {
				activeId = 2;
			}
		}, 2000);
	}

	onDestroy(() => {
		clearInterval(intervalId);
	});

	const champions = [
		{
			id: 0,
			name: 'Blitzcrank',
			image: `${PUBLIC_LOL_CDN_URL}/champion/Blitzcrank.png?fm=webp`,
			wr: '51.4%'
		},
		{
			id: 1,
			name: 'Maokai',
			image: `${PUBLIC_LOL_CDN_URL}/champion/Maokai.png?fm=webp`,
			wr: '55.9%'
		},
		{
			id: 2,
			name: 'Darius',
			image: `${PUBLIC_LOL_CDN_URL}/champion/Darius.png?fm=webp`,
			wr: '51.4%'
		},
		{
			id: 3,
			name: 'Bard',
			image: `${PUBLIC_LOL_CDN_URL}/champion/Bard.png?fm=webp`,
			wr: '52.5%'
		},
		{
			id: 4,
			name: 'Trundle',
			image: `${PUBLIC_LOL_CDN_URL}/champion/Trundle.png?fm=webp`,
			wr: '52.3%'
		},
		{
			id: 5,
			name: 'Blitzcrank',
			image: `${PUBLIC_LOL_CDN_URL}/champion/Blitzcrank.png?fm=webp`,
			wr: '51.4%'
		},
		{
			id: 6,
			name: 'Maokai',
			image: `${PUBLIC_LOL_CDN_URL}/champion/Maokai.png?fm=webp`,
			wr: '55.9%'
		}
	];
</script>

<div
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all lg:h-96"
	use:inview={options}
	on:inview_enter={() => {
		startAnimation();
	}}
	role="figure"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80 lg:h-96" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-8">
		<div class="row-span-3 mx-auto flex h-full w-full flex-col items-center justify-center">
			<div class="flex h-full w-full flex-row items-center justify-center gap-x-1 lg:gap-x-4">
				{#each champions as { id, name, image, wr }, i}
					{#if Math.abs(id - activeId) < 3}
						<div class="flex flex-col items-center justify-center gap-4 lg:gap-6">
							{#if activeId === id}
								<span class="text-lightPrimary text-center text-sm">{name}</span>
							{/if}
							<img
								loading="lazy"
								class={cn(
									'rounded-full object-cover',
									id === activeId && 'active h-[50px] w-[50px] lg:h-[70px] lg:w-[70px]',
									Math.abs(id - activeId) === 1 &&
										'h-[30px] w-[30px] opacity-50 lg:h-[50px] lg:w-[50px]',
									Math.abs(id - activeId) === 2 &&
										'h-[20px] w-[20px] opacity-20 lg:h-[30px] lg:w-[30px]'
								)}
								src={image}
								alt={name}
							/>
							{#if activeId === id}
								<Badge
									class="border-green-500/20 bg-green-200/5 px-2 py-1 text-xs font-normal text-green-300 hover:bg-green-400/20"
									>WR {wr}</Badge
								>
							{/if}
						</div>
					{/if}
				{/each}
			</div>
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">Tier Lists</h3>
			<p class="text-lightTertiary max-w-xs">
				See which champions are performing the best on the current live patch.
			</p>
		</div>
	</div>
</div>
